
import React from "react";
import { connect } from "react-redux";
import type { Dispatch } from "redux";
import autobind from "react-autobind";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { MainWrapper, GSDLogo, GSDLogoFull, MenuList } from "@gsd/backoffice-ui";
import { actions } from "@gsd/redux-store-backoffice";
import { IDM_MENU } from "../../constants/apps";

const {
  account: {
    creators: { getDashboardIdm }
  }
} = actions;

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getDashboard: () => dispatch(getDashboardIdm())
  };
};

type Props = {
    children: any,
    getDashboard: Function
};
type State = {
    collapsed: boolean,
    menu: Array<unknown>
};

const MenuLogo = (props: { collapsed?: boolean }) => {
  const { collapsed } = props;
  return (
    <Link to="/">
      <div className="text-center my-4">{collapsed === true ? <GSDLogo width={60} /> : <GSDLogoFull width={240} />}</div>
    </Link>
  );
};

class MainPage extends React.Component<Props, State> {
  state: State;
  constructor(props: Props) {
    super(props);
    this.state = {
      collapsed: false,
      menu: []
    };
    autobind(this);
  }

  async componentDidMount() {
    let dashboardSections = await this.props.getDashboard();
    dashboardSections =
            dashboardSections &&
            dashboardSections.length > 0 &&
            dashboardSections.map((section) => {
              const menu = IDM_MENU.find((menu) => menu.key === section.key) || { route: undefined, img: undefined };
              const { route, img } = menu;
              const { key, label } = section;
              return {
                key,
                label,
                img,
                wrapTagProps: {
                  to: route
                },
                wrapTag: Link,
                route
              };
            });
    this.setState({ menu: dashboardSections });
  }

  handleCollapse(_event: any, collapsed: boolean) {
    this.setState({
      ...this.state,
      collapsed
    });
  }

  render() {
    const { collapsed, menu } = this.state;
    return (
      <React.Fragment>
        <MainWrapper
          menuList={<MenuList menu={menu ? menu : []} collapsed={collapsed} />}
          logo={<MenuLogo collapsed={collapsed} />}
          onCollapse={this.handleCollapse}
        >
          {this.props.children}
        </MainWrapper>
      </React.Fragment>
    );
  }
}
export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(MainPage)
);
